import axios from 'axios';

function API() {
  return axios.create({
    baseURL: `${ajax_object.base_url}/wp-json/wp`, // the url of our server,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export default {
  suggestions(term = '') {
    return API().get(`v2/suggestions/?s=${term}`);
  },
  get(query, args = {}) {
    return API().get(
      `v2/advanced-search/?s=${query}`,
      { params: args }
    ).catch(() => {
      return API().get(`v2/search/?search=${encodeURIComponent(query)}&per_page=20`);
    });
  }
}


function convertQueryParams(data = {}) {
  const params = new URLSearchParams();

  Object.keys(data).forEach((dataItem) => {
    params.append(dataItem, data[dataItem]);
  });
  return params;
}
